import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { authGoogle } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      if (sessionId) {
        try { const r = await authGoogle(sessionId); setUser(r.user); } catch (err) { console.error("Google auth failed:", err); toast.error("La connexion Google a échoué. Réessayez."); }
      }
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/compte", { replace: true });
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <p className="font-serif-el italic text-dore text-xl">Connexion en cours...</p>
    </div>
  );
};

export default AuthCallback;
